// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle-button {
  position: relative;
  width: 53px;
  height: 24px;
  background-color: #ffffff;
  border-radius: 25px;
  cursor: pointer;
  border: 2px solid #0000006c;
  transition: background-color 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.404);

}

.button {
  position: absolute;
  top: 50%;
  left: 3px;
  width: 23px;
  height: 20px;
  background-color: #ffffff;
  border: 1px solid #000000af;
  border-radius: 45%;
  transform: translateY(-50%);
  transition: left 0.3s ease;
}

.on .button {
  left: 25px;
}

.toggle-button.on {
  background-color: rgba(0, 128, 0, 0.521);
}

.toggle-button.off {
  background-color: rgba(255, 0, 0, 0.685);
}

/* Tooltip */
.tooltip {
  visibility: hidden;
  width: 120px; /* Adjust width as needed */
  background-color: #ffffff00;
  color: #000000;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  top: 30px; /* Position below the button */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.4s;
}

.toggle-button:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

@media only screen and (max-width: 750px) {
  .toggle-button {
    margin-top: 1px;
    position: relative;
    width: 40px;
    height: 18px;
    background-color: #ffffff;
    border-radius: 25px;
    cursor: pointer;
    border: 2px solid #0000006c;
    transition: background-color 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.404);
  
  }
  
  .button {
    position: absolute;
    top: 50%;
    left: 0px;
    width: 20px;
    height: 17px;
    background-color: #ffffff;
    border: 1px solid #000000af;
    border-radius: 45%;
    transform: translateY(-50%);
    transition: left 0.3s ease;
  }
  
  .on .button {
    left: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/buttons/toggle_button/toggleButton.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,sCAAsC;EACtC,0CAA0C;;AAE5C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY,EAAE,2BAA2B;EACzC,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,SAAS,EAAE,8BAA8B;EACzC,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,2BAA2B;IAC3B,sCAAsC;IACtC,0CAA0C;;EAE5C;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".toggle-button {\n  position: relative;\n  width: 53px;\n  height: 24px;\n  background-color: #ffffff;\n  border-radius: 25px;\n  cursor: pointer;\n  border: 2px solid #0000006c;\n  transition: background-color 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.404);\n\n}\n\n.button {\n  position: absolute;\n  top: 50%;\n  left: 3px;\n  width: 23px;\n  height: 20px;\n  background-color: #ffffff;\n  border: 1px solid #000000af;\n  border-radius: 45%;\n  transform: translateY(-50%);\n  transition: left 0.3s ease;\n}\n\n.on .button {\n  left: 25px;\n}\n\n.toggle-button.on {\n  background-color: rgba(0, 128, 0, 0.521);\n}\n\n.toggle-button.off {\n  background-color: rgba(255, 0, 0, 0.685);\n}\n\n/* Tooltip */\n.tooltip {\n  visibility: hidden;\n  width: 120px; /* Adjust width as needed */\n  background-color: #ffffff00;\n  color: #000000;\n  text-align: center;\n  padding: 5px 0;\n  border-radius: 6px;\n  position: absolute;\n  z-index: 1;\n  top: 30px; /* Position below the button */\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  transition: opacity 0.4s;\n}\n\n.toggle-button:hover .tooltip {\n  visibility: visible;\n  opacity: 1;\n}\n\n@media only screen and (max-width: 750px) {\n  .toggle-button {\n    margin-top: 1px;\n    position: relative;\n    width: 40px;\n    height: 18px;\n    background-color: #ffffff;\n    border-radius: 25px;\n    cursor: pointer;\n    border: 2px solid #0000006c;\n    transition: background-color 0.3s ease;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.404);\n  \n  }\n  \n  .button {\n    position: absolute;\n    top: 50%;\n    left: 0px;\n    width: 20px;\n    height: 17px;\n    background-color: #ffffff;\n    border: 1px solid #000000af;\n    border-radius: 45%;\n    transform: translateY(-50%);\n    transition: left 0.3s ease;\n  }\n  \n  .on .button {\n    left: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
